import { isOrgGuideFileVersionExtant } from "@hex/common";

import { OrgGuideFileVersion } from "../../../../generated/graphqlTypes";
import { WorkbenchDiffStatus } from "../../../workbench/state/diffStatus";

type MinimalOrgGuideFileVersion = Pick<
  OrgGuideFileVersion,
  "id" | "contentsText"
>;
export function calculateOrgGuideFileDiffStatus({
  baseVersion,
  headVersion,
}: {
  baseVersion: MinimalOrgGuideFileVersion | null;
  headVersion: MinimalOrgGuideFileVersion | null;
}): WorkbenchDiffStatus {
  const isBaseVersionExtant = isOrgGuideFileVersionExtant(baseVersion);
  const isHeadVersionExtant = isOrgGuideFileVersionExtant(headVersion);
  if (isBaseVersionExtant && isHeadVersionExtant) {
    return baseVersion.contentsText === headVersion.contentsText
      ? WorkbenchDiffStatus.UNMODIFIED
      : WorkbenchDiffStatus.MODIFIED;
  } else if (isBaseVersionExtant) {
    return WorkbenchDiffStatus.DELETED;
  } else if (isHeadVersionExtant) {
    return WorkbenchDiffStatus.ADDED;
  } else {
    return WorkbenchDiffStatus.UNMODIFIED;
  }
}
